import { useWorkStore } from "@/store/student/work_store";
import {
    convertFullToHalfWidth,
    convertLatex,
    englishNormalization,
    remove_markdown_space_newline,
    societyNormalization,
    cleanFloatingNumbers
} from "@/util/remove_all";


class NormalizeAnswers {

    private selectedWork = useWorkStore().selectedWork
    private selectedWorkIndex = useWorkStore().selectedWorkIndex
    private isKeyboard = this.selectedWork[this.selectedWorkIndex]?.subject_field === '理科' || this.selectedWork[this.selectedWorkIndex]?.subject_field === '数学'
    private isEnglish = this.selectedWork[this.selectedWorkIndex]?.subject_field === '英語'
    private isSociety = this.selectedWork[this.selectedWorkIndex]?.subject.name === '社会'
    private isScience = this.selectedWork[this.selectedWorkIndex]?.subject_field === '理科'

    public normalizeUserAnswer(user_answer: string, remove_trailing_zero_sig_figs: boolean): string {
        if (this.isKeyboard) { // 数学・理科の場合
            user_answer = convertLatex(user_answer)
            // NFR-5920: remove floating-point numbers trailing zeros
            if(this.isScience && remove_trailing_zero_sig_figs) {
                user_answer = cleanFloatingNumbers(user_answer)
            }
        }
        else if (this.isEnglish) { // 英語の場合
            user_answer = englishNormalization(user_answer)
        }
        else if (this.isSociety) { // 社会の場合
            user_answer = societyNormalization(convertFullToHalfWidth(user_answer))
        }
        else { // その以外の場合
            user_answer = convertFullToHalfWidth(user_answer)
        }
        return user_answer
    }

    public normalizeQuizAnswer(quiz_answer: string, remove_trailing_zero_sig_figs: boolean): string {
        if (this.isKeyboard) { // 数学・理科の場合
            quiz_answer = convertLatex(quiz_answer)
            // NFR-5920: remove floating-point numbers trailing zeros
            if(this.isScience && remove_trailing_zero_sig_figs) {
                quiz_answer = cleanFloatingNumbers(quiz_answer)
            }
        }
        else if (this.isEnglish) { // 英語の場合
            quiz_answer = englishNormalization(remove_markdown_space_newline(quiz_answer))
        }
        else if (this.isSociety) { // 社会の場合
            quiz_answer = societyNormalization(convertFullToHalfWidth(remove_markdown_space_newline(quiz_answer)))
        }
        else { // その以外の場合
            quiz_answer = convertFullToHalfWidth(remove_markdown_space_newline(quiz_answer))
        }
        return quiz_answer
    }

}

export default NormalizeAnswers